// extracted by mini-css-extract-plugin
export var attribution = "_d6-4";
export var authorName = "_d6-5";
export var quote = "_d6-3";
export var testimonial = "_d6-2";
export var trustedBy = "_d6-0";
export var trustedByLabel = "_d6-1";